'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowExpanderUp, iconArrowExpanderUpTag } from '@ni/nimble-components/dist/esm/icons/arrow-expander-up';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowExpanderUp };
export { iconArrowExpanderUpTag };
export const NimbleIconArrowExpanderUp = wrap(IconArrowExpanderUp);